import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";

export const KeetaPurgeButton = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (user?.role !== "manager") return null;
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.keetaPurge();
      const n = Object.values(r.deleted || {}).reduce((a, b) => a + b, 0);
      toast.success(`تم حذف بيانات كيتا القديمة (${n} سجل)`);
      setOpen(false);
      setTimeout(() => window.location.reload(), 800);
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحذف"); } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="inline-flex items-center gap-1 rounded-full border border-rose-200 px-3 py-1.5 text-xs text-rose-600 hover:bg-rose-50" data-testid="keeta-purge-btn">
        <Trash2 className="h-3.5 w-3.5" /> حذف بيانات كيتا القديمة
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent dir="rtl" className="font-body">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-right">حذف كل بيانات «كيتا» القديمة؟</AlertDialogTitle>
            <AlertDialogDescription className="text-right leading-relaxed">
              يحذف نهائياً تقارير الأداء والمسافات والتقييمات والرواتب وفواتير الفري لانسر وتبويب راتب «كيتا» القديم، ويشيل «كيتا» من ملفات المناديب.
              بيانات «كيتا طلبات» و«كيتا شرائح» ما تتأثر. لا يمكن التراجع.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="gap-2">
            <AlertDialogCancel data-testid="keeta-purge-cancel">إلغاء</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); run(); }} disabled={busy} className="bg-rose-600 hover:bg-rose-700" data-testid="keeta-purge-confirm">
              {busy ? "جاري الحذف..." : "حذف نهائي"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
